<script setup lang="ts">
import { type PropType, ref } from 'vue'
import { useUserInfoStore } from '~/stores/useUserInfo'
import { userInfoAction } from '~/composables/userInfoAction'
import { useRoute } from '#vue-router'

const props = defineProps({
  info: {
    type: Object as PropType<any>,
    default: () => {},
  },
  config: {
    type: Object as PropType<any>,
    default: () => {},
  },
})

const { getUserInfo } = useUserInfoStore()

const { commonCollect } = userInfoAction()

/**
 * 获取报名配置
 */
// const { data: config } = await useAsyncData(() => getSignUpConfig({
//   configCodes: 'mFreeMeasuringRooms',
// }), {
//   transform: (res: any) => {
//     if (res.code === 0) {
//       return res?.dataBody[0]
//     }
//   },
// })

async function handleFree(e: any) {
  e.stopPropagation()
  await getUserInfo(true)
  await commonCollect({
    floorId: props.info?.floorId,
    configId: props.config?.configId,
    source: '新房/M版/户型详情装修案例',
    adviserList: props.info?.adviserList,
  })
}

const route = useRoute()
const domain = ref(route.fullPath[route.fullPath.length - 1] === '/' ? `` : `${route.params.domain}/`)
</script>

<template>
  <a :href="`/${domain}home/detailanli/${info.classicId}.html`" class="decorate-card">
    <div class="decorate-card-image">
      <van-image :src="$getImageSize(info?.cover, 'c380x335')" />
    </div>
    <div class="decorate-card-info">
      <div class="decorate-card-title">
        {{ info?.libraryStyle }}-{{ info?.buildArea }}㎡-{{ info?.houseFrame }}
      </div>
      <div class="decorate-card-company">
        {{ info?.companyName }}
      </div>
      <div class="link-btn" @click.prevent="handleFree">
        免费量房
      </div>
    </div>
  </a>
</template>

<style lang="scss" scoped>
@import "index.module";
</style>
